import { Descriptions, Input } from "antd";
import React, { useState } from "react";
import { INPUT_TYPE, lang, MODE_SCREEN, REGEX_INPUT, STYLE } from "../../../constants/common.const";

import classDdl from "../../../models/control/dropdownlist";
const ViewUsefulLifeMaster = ({
  mode,
  usefulLifeData,
  setUsefulLifeData,
  inputRefs,
  setIsFillData,
}) => {
  const handleChangeData =
    (key, type = INPUT_TYPE.INPUT, rule) =>
    (e) => {
      const value = type === INPUT_TYPE.SELECT ? e : e.target.value;
      if (rule && Array.isArray(rule) && rule.length > 0) {
        const isValid = rule.some((r) => r.test(value));
        if (!isValid) {
          return;
        }
      }
      if(String(value).length > 255){
        return;
      }
      setUsefulLifeData({
        ...usefulLifeData,
        [key]: {
          ...usefulLifeData[key],
          value,
        },
      });
      setIsFillData(true);
    };
  let fieldList = [
    {
      title: lang.TYPE_OF_WORK_NAME,
      key: "equipmentCategoryCode",
      value: usefulLifeData.equipmentCategoryCode,
      type: INPUT_TYPE.INPUT,
      disabled: mode === MODE_SCREEN.EDIT,
      isTitle: true,
      span: 1,
    },
    {
      title: lang.EQUIPMENT_CATEGORY_NAME,
      key: "equipmentCategoryName",
      value: usefulLifeData.equipmentCategoryName,
      type: INPUT_TYPE.INPUT,
      span: 4,
      hideTitle: true,
      isTitle: true,
    },

    {
      title: lang.EQUIP_CLASS_LARGE_NAME,
      key: "mainCategoryCode",
      value: usefulLifeData.mainCategoryCode,
      type: INPUT_TYPE.INPUT,
      span: 1,
      isTitle: true,
    },
    {
      title: lang.MAIN_CATEGORY_NAME,
      key: "mainCategoryName",
      value: usefulLifeData.mainCategoryName,
      type: INPUT_TYPE.INPUT,
      span: 4,
      hideTitle: true,
      isTitle: true,
    },
    {
      title: lang.EQUIP_CLASS_MIDDLE_NAME,
      key: "subCategoryCode",
      value: usefulLifeData.subCategoryCode,
      type: INPUT_TYPE.INPUT,
      span: 1,
      isTitle: true,
    },
    {
      title: lang.SUB_CATEGORY_NAME,
      key: "subCategoryName",
      value: usefulLifeData.subCategoryName,
      type: INPUT_TYPE.INPUT,
      span: 4,
      hideTitle: true,
      isTitle: true,
    },
    {
      title: lang.EQUIP_CLASS_SMALL_NAME,
      key: "smallCategoryCode",
      value: usefulLifeData.smallCategoryCode,
      type: INPUT_TYPE.INPUT,
      span: 1,
      isTitle: true,
    },
    {
      title: lang.SMALL_CATEGORY_NAME,
      key: "smallCategoryName",
      value: usefulLifeData.smallCategoryName,
      type: INPUT_TYPE.INPUT,
      span: 4,
      hideTitle: true,
      isTitle: true,
    },
    {
      title: lang.MATERIAL_NAME,
      key: "materialName",
      value: usefulLifeData.materialName,
      type: INPUT_TYPE.INPUT,
    },
    {
      title: lang.STANDARD_SERVICE_LIFE,
      key: "standardUsefulLife",
      value: usefulLifeData.standardUsefulLife,
      type: INPUT_TYPE.INPUT,
      required: true,
      rule: [REGEX_INPUT.INT_10],
    },

    {
      title: lang.TARGET_SERVICE_LIFE,
      key: "targetUsefulLife",
      value: usefulLifeData.targetUsefulLife,
      type: INPUT_TYPE.INPUT,
      required: true,
      rule: [REGEX_INPUT.INT_10],
    },

    {
      title: lang.DISPLAY_ORDER,
      key: "displayOrder",
      value: usefulLifeData.displayOrder,
      type: INPUT_TYPE.INPUT,
      disabled: true,
    },
  ];

  const renderItem = (item) => {
    if (item.component) return item.component;
    return mode === MODE_SCREEN.VIEW || item.isTitle ? (
      item.valueShow ||
        (item.value.value === undefined && typeof item.value === "string"
          ? item.value
          : item.value.value)
    ) : (
      <Input
        ref={(el) => (inputRefs.current[item.key] = el)}
        onChange={handleChangeData(item.key, item.type, item.rule)}
        value={item.value.value}
        disabled={item.disabled}
        className={item.value.error ? STYLE.BORDER_RED : ""}
        maxLength={item.key != "materialName" ? 2 :255}
        onInput={(e) => {
          if(item.key != "materialName"){
            e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 2);
          }
        }}
      />
    );
  };
  return (
    <div>
      <Descriptions  className="customEquipmentDes" size="small" column={5} bordered>
        {fieldList.map((item, index) => (
          <Descriptions.Item
            labelStyle={{
              width: "30%",
              fontWeight: "bold",
              display: item.hideTitle && "none",
            }}
            contentStyle={{ padding: "4px 4px", width: 70 }}
            key={index}
            label={
              <div
                style={{
                  cursor:
                    item.required && mode !== MODE_SCREEN.VIEW
                      ? "pointer"
                      : "default",
                  fontWeight: "bold",
                }}
                className="labelInputEquipment"
              >
                <span
                  style={{
                    color: item.required ? "#ff2255" : "",
                  }}
                >
                  {item.title}
                </span>
              </div>
            }
            span={item.span || 5}
          >
            {renderItem(item)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};

export default ViewUsefulLifeMaster;
